/**
 * @file コンポーネント：症例アイテム ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnPushDataLayerGtm } from "~/src/functions/common";

// コンポーネントを返す
export const Operation = (props) => {
    /**
     * Google Tag Manager カスタムイベントトリガー
     */
    useEffect(() => {
        if (
            props.labellist &&
            (props.labellist.indexOf("sponsor") !== -1 ||
                props.labellist.indexOf("promotion") !== -1)
        ) {
            fnPushDataLayerGtm({
                event: "AdViewCount",
                operationId: props.id,
                userId: window.dataUser.userId,
            });
        }
    }, []);

    /**
     * 症例タイトルのタグ
     */
    const [tagTitle, setTagTitle] = useState("h3");
    useEffect(() => {
        if (props.tag) {
            setTagTitle(props.tag);
        }
    }, [props.tag]);

    /**
     * スポンサーコンテンツクリックカウントを計測
     */
    const fnUpdateClickCount = (valuePromotionId, valueOperationId) => {
        const api = "/api/Promotions/log/click";
        const options = {
            body: JSON.stringify({
                promotionId: valuePromotionId,
                operationId: valueOperationId,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "PUT",
        };
        fetch(api, options);
    };

    // スポンサーコンテンツ表示回数を計測
    const fnUpdateViewCount = (valueId) => {
        const api = "/api/Promotions/log/view";
        const options = {
            body: JSON.stringify({ promotionIds: [valueId] }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "PUT",
        };
        fetch(api, options);
    };

    /**
     * Google Tag Manager カスタムイベントトリガー
     */
    const fnPushDataLayerAdClickCount = () => {
        if (
            props.labellist &&
            (props.labellist.indexOf("sponsor") !== -1 ||
                props.labellist.indexOf("promotion") !== -1)
        ) {
            fnPushDataLayerGtm({
                event: "AdClickCount",
                operationId: props.id,
                userId: window.dataUser.userId,
            });
        }
    };

    // ハードコードされたコラボレーション Operation ID リスト
    const collaborationOperationIds = [
        "OPEID-API-FY25-akagawa1-1",
        "OPEID-API-FY25-akagawa1-2",
        "OPEID-API-FY25-akagawa1-3",
        "OPEID-API-FY25-akagawa1-4",
        "OPEID-API-FY25-akagawa1-5",
        "OPEID-API-FY25-akagawa1-6",
        "OPEID-API-FY25-akagawa1-7",
        "OPEID-API-FY25-akagawa1-8",
        "OPEID-API-FY25-ichikawaEX1-1",
        "OPEID-API-FY25-kinoshita1-1",
        "OPEID-API-FY25-kinoshita1-10",
        "OPEID-API-FY25-kinoshita1-11",
        "OPEID-API-FY25-kinoshita1-2",
        "OPEID-API-FY25-kinoshita1-3",
        "OPEID-API-FY25-kinoshita1-4",
        "OPEID-API-FY25-kinoshita1-5",
        "OPEID-API-FY25-kinoshita1-6",
        "OPEID-API-FY25-kinoshita1-7",
        "OPEID-API-FY25-kinoshita1-8",
        "OPEID-API-FY25-kinoshita1-9",
        "OPEID-API-FY25-kinuta1-1",
        "OPEID-API-FY25-kinuta1-2",
        "OPEID-API-FY25-kinuta1-3",
        "OPEID-API-FY25-kinuta1-4",
        "OPEID-API-FY25-kinuta1-5",
        "OPEID-API-FY25-kinuta1-6",
        "OPEID-API-FY25-kinuta1-7",
        "OPEID-API-FY25-kinuta1-8",
        "OPEID-API-FY25-kinuta1-9",
        "OPEID-API-FY25-nunobe1-1",
        "OPEID-API-FY25-nunobe1-10",
        "OPEID-API-FY25-nunobe1-11",
        "OPEID-API-FY25-nunobe1-2",
        "OPEID-API-FY25-nunobe1-3",
        "OPEID-API-FY25-nunobe1-4",
        "OPEID-API-FY25-nunobe1-5",
        "OPEID-API-FY25-nunobe1-6",
        "OPEID-API-FY25-nunobe1-7",
        "OPEID-API-FY25-nunobe1-8",
        "OPEID-API-FY25-nunobe1-9",
        "OPEID-API-FY25-oomori1-1",
        "OPEID-API-FY25-oomori1-1-1",
        "OPEID-API-FY25-oomori1-2",
        "OPEID-API-FY25-oomori1-3",
        "OPEID-API-FY25-oomori1-4",
        "OPEID-API-FY25-oomori1-5",
        "OPEID-API-FY25-oomori1-6",
        "OPEID-API-FY25-oomori1-7",
        "OPEID-API-FY25-oomori1-8",
        "OPEID-API-FY25-terashimaEX1-1",
        "OPEID-API-FY25-tokunaga1-1",
        "OPEID-API-FY25-tokunaga1-2",
        "OPEID-API-FY25-tokunaga1-3",
        "OPEID-API-FY25-tokunaga1-4",
        "OPEID-API-FY25-tokunaga1-5",
        "OPEID-API-FY25-tokunaga1-6",
        "OPEID-API-FY25-tokunaga1-7",
        "OPEID-API-FY25-tokunaga1-8",
        "OPEID-API-FY25-tokunaga1-9",
        //追加１
        "OPEID-API-FY25-kinoshita1-1-limited",
        "OPEID-API-FY25-kinoshita1-10-limited",
        "OPEID-API-FY25-kinoshita1-11-limited",
        "OPEID-API-FY25-kinoshita1-2-limited",
        "OPEID-API-FY25-kinoshita1-3-limited",
        "OPEID-API-FY25-kinoshita1-4-limited",
        "OPEID-API-FY25-kinoshita1-5-limited",
        "OPEID-API-FY25-kinoshita1-6-limited",
        "OPEID-API-FY25-kinoshita1-7-limited",
        "OPEID-API-FY25-kinoshita1-8-limited",
        "OPEID-API-FY25-kinoshita1-9-limited",
        "OPEID-API-FY25-tokunaga1-1-limited",
        "OPEID-API-FY25-tokunaga1-2-limited",
        "OPEID-API-FY25-tokunaga1-3-limited",
        "OPEID-API-FY25-tokunaga1-4-limited",
        "OPEID-API-FY25-tokunaga1-5-limited",
        "OPEID-API-FY25-tokunaga1-6-limited",
        "OPEID-API-FY25-tokunaga1-7-limited",
        "OPEID-API-FY25-tokunaga1-8-limited",
        "OPEID-API-FY25-tokunaga1-9-limited",
        "OPEID-API-FY25-oomori1-1-1-limited",
        "OPEID-API-FY25-oomori1-2-limited",
        "OPEID-API-FY25-oomori1-3-limited",
        "OPEID-API-FY25-oomori1-4-limited",
        "OPEID-API-FY25-oomori1-5-limited",
        "OPEID-API-FY25-oomori1-6-limited",
        "OPEID-API-FY25-oomori1-7-limited",
        "OPEID-API-FY25-oomori1-8-limited",
        "OPEID-API-FY25-nunobe1-1-limited",
        "OPEID-API-FY25-nunobe1-10-limited",
        "OPEID-API-FY25-nunobe1-11-limited",
        "OPEID-API-FY25-nunobe1-2-limited",
        "OPEID-API-FY25-nunobe1-3-limited",
        "OPEID-API-FY25-nunobe1-4-limited",
        "OPEID-API-FY25-nunobe1-5-limited",
        "OPEID-API-FY25-nunobe1-6-limited",
        "OPEID-API-FY25-nunobe1-7-limited",
        "OPEID-API-FY25-nunobe1-8-limited",
        "OPEID-API-FY25-nunobe1-9-limited",
        "OPEID-API-FY25-kinuta1-1-limited",
        "OPEID-API-FY25-kinuta1-2-limited",
        "OPEID-API-FY25-kinuta1-3-limited",
        "OPEID-API-FY25-kinuta1-4-limited",
        "OPEID-API-FY25-kinuta1-5-limited",
        "OPEID-API-FY25-kinuta1-6-limited",
        "OPEID-API-FY25-kinuta1-7-limited",
        "OPEID-API-FY25-kinuta1-8-limited",
        "OPEID-API-FY25-kinuta1-9-limited",
        "OPEID-API-FY25-akagawa1-1-limited",
        "OPEID-API-FY25-akagawa1-2-limited",
        "OPEID-API-FY25-akagawa1-3-limited",
        "OPEID-API-FY25-akagawa1-4-limited",
        "OPEID-API-FY25-akagawa1-5-limited",
        "OPEID-API-FY25-akagawa1-6-limited",
        "OPEID-API-FY25-akagawa1-7-limited",
        "OPEID-API-FY25-akagawa1-8-limited",
        "OPEID-API-FY25-ichikawaEX1-1-limited",
        "OPEID-API-FY25-terashimaEX1-1-limited",
        //追加２
        "OPEID-API-FY25-kurokawa1-1",
        "OPEID-API-FY25-kurokawa1-2",
        "OPEID-API-FY25-kurokawa1-3",
        "OPEID-API-FY25-kurokawa1-4",
        "OPEID-API-FY25-kurokawa1-5",
        "OPEID-API-FY25-kurokawa1-6",
        "OPEID-API-FY25-kurokawa1-7",
        "OPEID-API-FY25-kurokawa1-1-limited",
        "OPEID-API-FY25-kurokawa1-2-limited",
        "OPEID-API-FY25-kurokawa1-3-limited",
        "OPEID-API-FY25-kurokawa1-4-limited",
        "OPEID-API-FY25-kurokawa1-5-limited",
        "OPEID-API-FY25-kurokawa1-6-limited",
        "OPEID-API-FY25-kurokawa1-7-limited",
        //追加３
        "OPEID-API-FY25-obama1-1",
        "OPEID-API-FY25-obama1-2",
        "OPEID-API-FY25-obama1-3new",
        "OPEID-API-FY25-obama1-4",
        "OPEID-API-FY25-obama1-5",
        "OPEID-API-FY25-obama1-6",
        "OPEID-API-FY25-obama1-7",
        "OPEID-API-FY25-obama1-1-limited",
        "OPEID-API-FY25-obama1-2-limited",
        "OPEID-API-FY25-obama1-3new-limited",
        "OPEID-API-FY25-obama1-4-limited",
        "OPEID-API-FY25-obama1-5-limited",
        "OPEID-API-FY25-obama1-6-limited",
        "OPEID-API-FY25-obama1-7-limited",
        //追加４
        "OPEID-API-FY25-kinoshita2-1",
        "OPEID-API-FY25-kinoshita2-2",
        "OPEID-API-FY25-kinoshita2-3",
        "OPEID-API-FY25-kinoshita2-4",
        "OPEID-API-FY25-kinoshita2-5new",
        "OPEID-API-FY25-kinoshita2-6",
        "OPEID-API-FY25-kinoshita2-7",
        "OPEID-API-FY25-kinoshita2-8",
        "OPEID-API-FY25-kinoshita2-9",
        "OPEID-API-FY25-kinoshita2-1-limited",
        "OPEID-API-FY25-kinoshita2-2-limited",
        "OPEID-API-FY25-kinoshita2-3-limited",
        "OPEID-API-FY25-kinoshita2-4-limited",
        "OPEID-API-FY25-kinoshita2-5new-limited",
        "OPEID-API-FY25-kinoshita2-6-limited",
        "OPEID-API-FY25-kinoshita2-7-limited",
        "OPEID-API-FY25-kinoshita2-8-limited",
        "OPEID-API-FY25-kinoshita2-9-limited",
        //追加5
        "OPEID-API-FY25-kandaEX1-1new",
        "OPEID-API-FY25-kandaEX1-1new-limited",
        //追加6
        "OPEID-API-FY25-kuroda1-1",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-2",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-3",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-4",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-5",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-6",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-7",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-8",  //CategoryCode=247
        "OPEID-API-FY25-kuroda1-9",  //CategoryCode=247
        //追加7
        "OPEID-API-FY25-kinuta2-1",  //CategoryCode=255
        "OPEID-API-FY25-kinuta2-2",  //CategoryCode=255
        "OPEID-API-FY25-kinuta2-3",  //CategoryCode=255
        "OPEID-API-FY25-kinuta2-4",  //CategoryCode=255
        "OPEID-API-FY25-kinuta2-5",  //CategoryCode=255
        "OPEID-API-FY25-kinuta2-6",  //CategoryCode=255
        "OPEID-API-FY25-kinuta2-7",  //CategoryCode=255
        //追加8
        "OPEID-API-FY25-okiEX1-1",  //CategoryCode=229
        //追加9
        "OPEID-API-FY25-sato1-1",  //CategoryCode=257
        "OPEID-API-FY25-sato1-2",  //CategoryCode=257
        "OPEID-API-FY25-sato1-3",  //CategoryCode=257
        "OPEID-API-FY25-sato1-4",  //CategoryCode=257
        "OPEID-API-FY25-sato1-5",  //CategoryCode=257
        "OPEID-API-FY25-sato1-6",  //CategoryCode=257
        "OPEID-API-FY25-sato1-7",  //CategoryCode=257
        "OPEID-API-FY25-sato1-8new",  //CategoryCode=257
        //追加10
        "OPEID-API-FY25-tokunagaEX1-1new",  //CategoryCode=229
        //追加11
        "OPEID-API-FY25-inaki1-1",  //CategoryCode=262
        "OPEID-API-FY25-inaki1-2",  //CategoryCode=262
        "OPEID-API-FY25-inaki1-3",  //CategoryCode=262
        "OPEID-API-FY25-inaki1-4",  //CategoryCode=262
        "OPEID-API-FY25-inaki1-5",  //CategoryCode=262
        //追加12
        "OPEID-API-FY26-sahara1-1", //CategoryCode=264
        "OPEID-API-FY26-sahara1-2", //CategoryCode=264
        "OPEID-API-FY26-sahara1-3", //CategoryCode=264
        "OPEID-API-FY26-sahara1-4", //CategoryCode=264
        "OPEID-API-FY26-sahara1-5", //CategoryCode=264
        "OPEID-API-FY26-sahara1-6", //CategoryCode=264
        "OPEID-API-FY26-sahara1-7", //CategoryCode=264
        //追加13
        "OPEID-API-FY26-imatakaEX1", //CategoryCode=229
        //追加14
        "OPEID-API-FY26-makuuchi1-1", //CategoryCode=266
        "OPEID-API-FY26-makuuchi1-2", //CategoryCode=266
        "OPEID-API-FY26-makuuchi1-3new", //CategoryCode=266
        //追加15
        "OPEID-API-FY26-inaki1-1",    //CategoryCode=274
        "OPEID-API-FY26-inaki1-2new", //CategoryCode=274
        "OPEID-API-FY26-inaki1-3",    //CategoryCode=274
        "OPEID-API-FY26-inaki1-4new", //CategoryCode=274
        "OPEID-API-FY26-inaki1-5",    //CategoryCode=274
        "OPEID-API-FY26-inaki1-6",    //CategoryCode=274
        "OPEID-API-FY26-inaki1-701",  //CategoryCode=274
        //追加16
        "OPEID-API-FY26-bouoka1", //CategoryCode=229
        //追加17
        "OPEID-API-FY26-yamashita1-1", //CategoryCode=275
        "OPEID-API-FY26-yamashita1-2", //CategoryCode=275
        "OPEID-API-FY26-yamashita1-3", //CategoryCode=275
        "OPEID-API-FY26-yamashita1-4", //CategoryCode=275
        "OPEID-API-FY26-yamashita1-5", //CategoryCode=275
        //追加18
        "OPEID-API-FY26-hayami1", //CategoryCode=276
        "OPEID-API-FY26-hayami2", //CategoryCode=276
        "OPEID-API-FY26-hayami3", //CategoryCode=276
        "OPEID-API-FY26-hayami4", //CategoryCode=276
        "OPEID-API-FY26-hayami5", //CategoryCode=276
    ];

    // 判定：有効な ID に含まれているか
    const isCollaboration = collaborationOperationIds.includes(props.id);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnPushDataLayerAdClickCount={fnPushDataLayerAdClickCount}
            fnUpdateClickCount={fnUpdateClickCount}
            fnUpdateViewCount={fnUpdateViewCount}
            tagTitle={tagTitle}
            isCollaboration={isCollaboration}
        />
    );
};
